const WEEKDAYS = ["日", "月", "火", "水", "木", "金", "土"];

export function toIsoDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function parseIsoDate(value) {
  const [year, month, day] = value.split("-").map(Number);
  return new Date(year, month - 1, day);
}

export function getCurrentPeriodStart(now = new Date()) {
  if (now.getDate() >= 16) {
    return new Date(now.getFullYear(), now.getMonth(), 16);
  }
  return new Date(now.getFullYear(), now.getMonth() - 1, 16);
}

export function movePeriod(periodStart, offset) {
  const date =
    typeof periodStart === "string" ? parseIsoDate(periodStart) : periodStart;
  return new Date(date.getFullYear(), date.getMonth() + offset, 16);
}

export function buildPeriodDates(periodStart) {
  const start =
    typeof periodStart === "string" ? parseIsoDate(periodStart) : periodStart;
  const end = new Date(start.getFullYear(), start.getMonth() + 1, 15);
  const dates = [];

  for (
    let cursor = new Date(start);
    cursor <= end;
    cursor.setDate(cursor.getDate() + 1)
  ) {
    const date = new Date(cursor);
    dates.push({
      iso: toIsoDate(date),
      day: date.getDate(),
      month: date.getMonth() + 1,
      weekday: WEEKDAYS[date.getDay()],
      isWeekend: date.getDay() === 0 || date.getDay() === 6,
    });
  }

  return dates;
}

export function formatPeriodLabel(periodStart) {
  const start =
    typeof periodStart === "string" ? parseIsoDate(periodStart) : periodStart;
  const end = new Date(start.getFullYear(), start.getMonth() + 1, 15);
  return `${start.getFullYear()}年${start.getMonth() + 1}月16日〜${
    end.getMonth() + 1
  }月15日`;
}
